import { render } from "./DeadManSwitch.vue?vue&type=template&id=6e1c8d5f&lang=pug"
import script from "./DeadManSwitch.vue?vue&type=script&lang=js"
export * from "./DeadManSwitch.vue?vue&type=script&lang=js"

import exportComponent from "/home/apognu/code/personal/defcon/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__